import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	drawerOpen: false,
	routeHistory: [],
	saveDashboardFormStates: false,  
};
export const globalSlice = createSlice({
	name: "global",
	initialState,
	reducers: {
		setGlobalState: {
			prepare(stateName, stateValue) {
				return {
					payload: { stateName, stateValue },
				};
			},
			reducer(state, action) {
				const { stateName, stateValue } = action.payload;
				state[stateName] = stateValue;
			},
		},
		pushRoute: (state, action) => {
			state.routeHistory.push(action.payload);
			// keeping the array size upto 10 so that it doesn't use too much memory
			if (state.routeHistory.length > 10) {
			  let smallerHistory = state.routeHistory.slice(5);
			  state.routeHistory = smallerHistory;
			}
		},
		setSaveDashboardFormState: (state, action) => {
			state.saveDashboardFormStates = action.payload;
		}
	},
});

export const { setGlobalState, pushRoute, setSaveDashboardFormState } = globalSlice.actions;
export default globalSlice.reducer;
